import { css } from "@emotion/css";
import { ReactNode, useRef, useState } from "react";
import { getToken } from "src/utils/getToken";
import message from "src/utils/message";
import tw from "src/utils/tw";

interface Props {
  accept?: string;
  children: ReactNode;
  onChange?: (file) => void;
}

export function InputUpload(props: Props) {
  const [uploading, setUploading] = useState(false);
  const ref = useRef(null);

  async function onChange(e) {
    const accessToken = getToken();
    const photo = e.target.files[0];
    const formData = new FormData();
    formData.append("data", photo);

    setUploading(true);
    const processingMessage = message.loading("Uploading…");

    try {
      const headers = {};

      if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
      }

      const upload = await fetch(process.env.NEXT_PUBLIC_CLIENT_FILE_ENDPOINT, {
        method: "POST",
        body: formData,
        headers,
      });

      const json = await upload.json();

      console.log("json", json);

      if (json.url) {
        props.onChange(json);
      } else {
        props.onChange(null);
        message.error(json.message);
      }
    } catch (e) {
      console.log("e", e);
      message.error(e);
    }

    processingMessage();
    setUploading(false);

    if (ref.current) {
      ref.current.value = "";
    }
  }

  return (
    <div>
      <div className="relative inline-block">
        <input
          type="file"
          accept={props.accept ? props.accept : ".png, .jpg, .jpeg, .gif"}
          className={tw(
            css({
              ["::-webkit-file-upload-button"]: { cursor: "pointer" },
            }),
            "absolute left-0 top-0 h-full w-full cursor-pointer opacity-0"
          )}
          onChange={onChange}
          ref={ref}
          disabled={uploading}
        />
        {props.children}
      </div>
    </div>
  );
}
